import { render, staticRenderFns } from "./UploadFile.vue?vue&type=template&id=503e956c&scoped=true"
import script from "./UploadFile.vue?vue&type=script&lang=ts"
export * from "./UploadFile.vue?vue&type=script&lang=ts"
import style0 from "./UploadFile.vue?vue&type=style&index=0&id=503e956c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "503e956c",
  null
  
)

export default component.exports